__turbopack_context__.v({
  "articleDate": "Article-module__OSC4UG__articleDate",
  "articleFigure": "Article-module__OSC4UG__articleFigure",
  "articleHeading": "Article-module__OSC4UG__articleHeading",
  "articleImage": "Article-module__OSC4UG__articleImage",
  "content": "Article-module__OSC4UG__content",
  "grow": "Article-module__OSC4UG__grow",
  "readProgress": "Article-module__OSC4UG__readProgress",
  "root": "Article-module__OSC4UG__root",
});
